export const getImageURL = (id: string | undefined) => {
  if (!id) return ""
  
  const httpLink =
    process.env.NODE_ENV !== "production"
      ? "http://localhost:8080/api/img"
      : "/api/img"
  
  return `${httpLink}/${id}`
}

// Convert image URL to base64 for PDF generation
export const getImageAsBase64 = async (id: string | undefined): Promise<string | null> => {
  if (!id) return null
  
  try {
    const imageUrl = getImageURL(id)
    if (!imageUrl) return null
    
    const response = await fetch(imageUrl, {
      credentials: "include",
    })
    if (!response.ok) {
      console.error(`Failed to fetch image ${id}: ${response.status}`)
      return null
    }
    
    const blob = await response.blob()
    
    return new Promise((resolve) => {
      const reader = new FileReader()
      reader.onloadend = () => {
        let base64data = reader.result as string
        
        if (base64data) {
          // Extract the base64 portion
          const [header, base64Only] = base64data.split(',')
          
          // Detect actual image format from base64 data
          // JPEG magic number in base64: /9j/
          // PNG magic number in base64: iVBORw0K
          // GIF magic number in base64: R0lGOD
          let detectedMimeType = 'image/png' // default
          
          if (base64Only.startsWith('/9j/')) {
            detectedMimeType = 'image/jpeg'
          } else if (base64Only.startsWith('iVBORw0K')) {
            detectedMimeType = 'image/png'
          } else if (base64Only.startsWith('R0lGOD')) {
            detectedMimeType = 'image/gif'
          }
          
          // Always use the detected MIME type to ensure consistency
          const correctedDataUrl = `data:${detectedMimeType};base64,${base64Only}`
          
          // Image fetch completed
          
          resolve(correctedDataUrl)
        } else {
          resolve(null)
        }
      }
      reader.onerror = (error) => {
        console.error(`Error reading image ${id}:`, error)
        resolve(null)
      }
      reader.readAsDataURL(blob)
    })
  } catch (error) {
    console.error(`Error converting image ${id} to base64:`, error)
    return null
  }
}
